import { DocumentItem } from "./document-item";
import { DocumentItemDetail } from "./document-item-detail";

import { Entity } from "../base/entity";
import { DocumentPartijaSpecifikacija } from "./document-partija-specifikacija";
import { Partner } from "../lookups/partner";
import { DocumentContact } from "../lookups/document-contact";
import { NacinOtpreme } from "../lookups/nacin-otpreme";
import { DocumentAddress } from "../lookups/DocumentAddress";
import { Company } from "../lookups/company";

export class Document extends Entity {
  public static readonly TABLENAME = "document";

  public static readonly ID = "id";
  public static readonly DOCUMENT_TYPE_ID = "document_type_id";
  public static readonly STOCKROOM_ID = "stockroom_id";
  public static readonly PARTNER_ID = "partner_id";
  public static readonly EID = "eid";
  public static readonly PARTNER_SHORT_NAME = "partner_short_name";
  public static readonly DOCUMENT_NUMBER = "document_number";
  public static readonly PARENT_DOCUMENT_NUMBER = "parent_document_number";
  public static readonly DOCUMENT_DATE = "document_date";
  public static readonly EXTERNAL_NUMBER = "external_number";
  public static readonly EXTERNAL_DATE = "external_date";
  public static readonly DATE = "date";
  public static readonly DESCRIPTION = "description";
  public static readonly STOCKROOM_RECIPIENT = "stockroom_recipient";
  public static readonly TOTAL = "total";
  public static readonly VAT_IND = "vat_ind";
  public static readonly TOTAL_VAT = "total_vat";
  public static readonly DATE_VAT = "date_vat";
  public static readonly DEADLINE_INVOICING = "deadline_invoicing";
  public static readonly DEADLINE_PAYMENT = "deadline_payment";
  public static readonly CASH_DISCOUNT_PERCENT = "cash_discount_percent";
  public static readonly CASH_DISCOUNT_DEADLINE = "cash_discount_deadline";
  public static readonly COMMENT = "comment";
  public static readonly PARENT_ID = "parent_id";
  public static readonly CONTRACT_ID = "contract_id";
  public static readonly CONTRACT_NUMBER = "contract_number";
  public static readonly STATUS = "status";
  public static readonly RATE = "rate";
  public static readonly CURRENCY_ID = "currency_id";
  public static readonly VAT_ID = "vat_id";
  public static readonly CLAUSES = "clauses";
  public static readonly CREATED_AT = "created_at";
  public static readonly UPDATED_AT = "updated_at";
  public static readonly DELETED_AT = "deleted_at";

  public static readonly ULAZNA_KALKULACIJA = "ulaznaKalkulacija";
  public static readonly KNJIZNO_ODOBRENJE = "knjiznoOdobrenje";
  public static readonly PROFAKTURA = "profaktura";
  public static readonly FAKTURA = "faktura";
  public static readonly OTPREMNICA = "otpremnica";
  public static readonly ULAZNA_OTPREMNICA = "ulaznaOtpremnica";
  public static readonly INTERNO_IZDAVANJE_ROBE = "internoIzdavanjeRobe";
  public static readonly NIVELACIJA = "nivelacija";
  public static readonly POPISNA_LISTA = "popisnaLista";
  public static readonly RAZLIKE_ZALIHA = "razlikeZaliha";
  public static readonly INTERNI_PRIJEM_ROBE = "interniPrijemRobe";
  public static readonly POCETNO_STANJE = "pocetnoStanje";
  public static readonly POVRACAJ_ROBE_OD_KUPCA = "povracajRobeOdKupca";
  public static readonly POVRACAJ_ROBE_DOBAVLJACU = "povracajRobeDobavljacu";
  public static readonly TERBOVANJE = "trebovanje";
  public static readonly PRIJEMNICA = "prijemnica";
  public static readonly SKART = "skart";
  public static readonly UTROSAK = "utrosak";
  public static readonly PORUDZBENICA = "porudzbenica";
  public static readonly NALOG_ZA_IZDAVANJE = "nalogZaIzdavanje";
  public static readonly RADNI_NALOG = "radniNalog";
  public static readonly RASHOD = "rashod";
  public static readonly VISAK = "visak";
  public static readonly MANJAK = "manjak";
  public static readonly PRIMLJENI_AVANS = "primljeniAvans";

  public static readonly CUSTOMER_ID = "customer_id";

  public static readonly NABAVKA_ID = "nabavka_id";

  public static readonly KALKULACIJA_CENA = "kalkulacijaCena";

  public static readonly SITUACIJA = "situacija";
  public static readonly PRINT_SERIAL = "printSerial";

  public static readonly DATUM_OTPREME = "datum_otpreme";
  public static readonly POCETAK_OTPREME = "pocetak_otpreme";
  public static readonly ZAVRSETAK_OTPREME = "zavrsetak_otpreme";

  public static readonly BROJ_PAKETA = "broj_paketa";
  public static readonly TEZINA_ISPORUKE = "tezina_isporuke";
  public static readonly UNIT_T = "unit_t";

  public static readonly ZAPREMINA_ISPORUKE = "zapremina_isporuke";
  public static readonly UNIT_ZI = "unit_zi";

  public static readonly NACIN_OTPREME = "nacin_otpreme";

  public static readonly POSILJALAC_ADRESA = "posiljalac_adresa";
  public static readonly PRIMALAC_ADRESA = "primalac_adresa";
  public static readonly OTPREMA_ADRESA = "otprema_adresa";
  public static readonly ODREDISTE_ADRESA = "odrediste_adresa";

  public static readonly POSILJALAC_KONTAKT = "posiljalac_kontakt";
  public static readonly PRIMALAC_KONTAKT = "primalac_kontakt";
  public static readonly PREVOZIK_KONTAKT = "prevozik_kontakt";

  public static readonly BROJ_VOZILA = "broj_vozila";

  documentItems: DocumentItem[];
  documentItemDetails: DocumentItemDetail[];
  documentPS: DocumentPartijaSpecifikacija[];
  partner: Partner;

  id: string;
  documentTypeId: number;
  stockroomId: string;
  partnerId: string;
  carrierId: string;
  eid: string;
  eotpremnicaRequestId: string;
  partnerShortName: string;
  documentNumber: string;
  parentDocumentNumber: string;
  documentDate: Date;
  externalNumber: string;
  externalDate: Date;
  date: Date;
  description: string;
  stockroomRecipient: string;
  total: number;
  vatInd: boolean;
  totalVat: number;
  dateVat: Date;
  deadlineInvoicing: number;
  deadlinePayment: number;
  cashDiscountPercent: number;
  cashDiscountDeadline: number;
  comment: string;
  parentId: string;
  contractId: string;
  contractNumber: string;
  status: string;
  rate: number;
  currencyId: string;
  vatId: number;
  clauses: string;
  reservation: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  appUserId: number;
  customerId: number;
  isforosnovnosredstvo: boolean;
  nabavkaId: string;
  printSerial: boolean;
  datumOtpreme: Date;
  pocetakOtpreme: Date;
  zavrsetakOtpreme: Date;
  brojPaketa: number;
  tezinaIsporuke: number;
  unitT: number;
  zapreminaIsporuke: number;
  unitZi: number;
  nacinOtpreme: number;
  brojVozila: string;
  mestoUtovara: string;
  mestoIsporuke: string;

  otpremaAdresa: DocumentAddress;
  odredisteAdresa: DocumentAddress;
  prevozikKontakt: DocumentContact;
  posiljalacAddress: Company;
  primalacAddress: Partner;
  posiljalacKontakt: DocumentContact;
  primalacKontakt: DocumentContact;
  carrier: Partner;

  nacinOtpremeObj?: NacinOtpreme | null;

  get shortName(): string {
    if (this.partnerShortName) {
      return this.partnerShortName;
    }
    if (this.partner && this.partner.shortName) {
      return this.partner.shortName;
    }
    return "";
  }

  constructor(data?: Partial<Document>) {
    super(data);

    Object.assign(this, data);

    this.otpremaAdresa =
      data && data.otpremaAdresa
        ? new DocumentAddress(data.otpremaAdresa)
        : new DocumentAddress({});

    this.odredisteAdresa =
      data && data.odredisteAdresa
        ? new DocumentAddress(data.odredisteAdresa)
        : new DocumentAddress({});

    this.prevozikKontakt =
      data && data.prevozikKontakt
        ? new DocumentContact(data.prevozikKontakt)
        : new DocumentContact({});

    this.carrier =
      data && data.carrier ? new Partner(data.carrier) : new Partner({});

    this.documentItemDetails =
      data && data.documentItemDetails
        ? data.documentItemDetails.map(
            (detail) => new DocumentItemDetail(detail),
          )
        : [];
  }
}
